// extracted by mini-css-extract-plugin
module.exports = {"sideNav":"sidenav_sideNav__3Z4J2","open":"sidenav_open__3GuWa"};